// extracted by mini-css-extract-plugin
export default {"avatar":"Jj8dBE","withBorder":"xet8YY","filter":"ViJ35h"};